module.exports = __webpack_public_path__ + "3dceeef6d3bc28e6e654bab83834d38a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/image-resources/poly-bg/poly-bg-6.jpg
// module id = 395
// module chunks = 0